export const CANCEL_SALES_INVOICE = gql`
    mutation CancelSalesInvoice($input: CancelInvoiceInput!) {
        cancelSalesInvoice(input: $input) {
            id
        }
    }
`;
